export default {
  mounted: el => {
    setTimeout(() => {
      el.querySelector('ion-input').getInputElement().then(input => input.addEventListener('focus', () => {
        el.click()
      }))
    }, 100)
  }
}
